class ProductScale {
  constructor() {
    this.initScaleOberserver();
  }

  initScaleOberserver() {
    if (!window.IntersectionObserver) {
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) {
            return;
          }
          console.log(entry);
          entry.target
            .querySelector(".product-scale__bar")
            .classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      },
      {
        rootMargin: "0px 0px -100px 0px",
      }
    );
    document.querySelectorAll(".product-scale").forEach((scale) => {
      observer.observe(scale);
    });
  }
}

export default ProductScale;
